import { config } from "react-spring"

const springObj = {
  to: { opacity: 1, transform: "translate(0px, 0px)" },
  from: { opacity: 0, transform: "translate(0px, 100px)" },
  config: config.wobbly,
}

export default springObj
